export default "__VITE_ASSET__txd0M3OF__"